import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
import AnimationLayout from '@/components/animation/AnimationLayout';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();
  const transactionCode = localStorage.getItem('transactionCode');

  // Redirect to dashboard if already authenticated
  if (isAuthenticated && transactionCode) {
    return <Navigate to="/transaction-code" replace />;
  } else if (isAuthenticated && !transactionCode) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <div
        className="min-h-screen text-white flex flex-col p-5 overflow-hidden"
        style={{
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* <AnimationLayout /> */}
        {/* Rotated background image */}
        {/* <div
          className="absolute inset-0 z-0  origin-center"
         
        /> */}

        {/* Logo */}
        {/* <img src={`${imagekit}/login/logo.svg`} alt="" className="w-40 relative z-10" /> */}

        {/* Centered Section */}
        <AnimationLayout>
          <div className="flex-grow flex-center relative z-10">
            <div className="relative max-w-[560px] w-full mx-auto flex-center flex-col">
              {/* <img src={`${imagekit}/login/logo.svg`} alt="" className="w-80 relative z-10 mb-10" /> */}
              <Outlet />
            </div>
          </div>
        </AnimationLayout>
      </div>
    </>
  );
}
